(() => {
 const match=location.pathname.match(/^\/(?:th\/|zh\/)?pages\/(artwork-[a-z0-9-]+)$/);
 const status=document.querySelector('.aart-shared-status');
 if(!match||!status)return;
 const publicText=status.textContent;
 let generation=0,controller=null,expiryTimer=null;
 function clear(){generation++;clearTimeout(expiryTimer);expiryTimer=null;controller?.abort();controller=null;status.textContent=publicText;}
 async function check(){
  clear();
  if(document.hidden||!navigator.onLine)return;
  const current=generation;
  const pending=new AbortController();controller=pending;
  const timeout=setTimeout(()=>pending.abort(),8000);
  try{
   const r=await fetch('https://collectors.charoenaart.com/api/price/'+match[1],{credentials:'omit',cache:'no-store',redirect:'error',signal:pending.signal});
   if(!r.ok)return;
   const data=await r.json();
   if(current!==generation||pending.signal.aborted||document.hidden||!navigator.onLine)return;
   const remaining=data.expiresAt*1000-Date.now();
   if(data.state==='price'&&typeof data.amount==='string'&&/^\d+(?:\.\d{1,2})?$/.test(data.amount)&&Number(data.amount)>0&&/^[A-Z]{3}$/.test(data.currency)&&Number.isSafeInteger(data.expiresAt)&&remaining>0&&remaining<=15000){
    status.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency,currencyDisplay:'code'}).format(Number(data.amount));
    expiryTimer=setTimeout(()=>{if(current===generation)clear();},remaining);
   }
  }catch{if(current===generation)clear();}
  finally{clearTimeout(timeout);if(current===generation)controller=null;}
 }
 document.addEventListener('visibilitychange',()=>{clear();if(!document.hidden)check();});
 window.addEventListener('offline',clear);
 window.addEventListener('online',check);
 window.addEventListener('pagehide',clear);
 window.addEventListener('pageshow',check);
 navigator.connection?.addEventListener('change',check);
 setInterval(check,15000);
 check();
})();